export default {
    sexo: ''
}
